import { MoniebookLogo } from '@moniebook-web/icons-v2/logos/moniebook-logo';
import { COOKIE_KEYS, removeCookie } from '@register-ui/utils';
import { useEffect } from 'react';
import { useAppDownloadLinks } from './use-download-links';

export function DesktopOnly() {
    const { link } = useAppDownloadLinks();

    useEffect(() => {
        removeCookie(COOKIE_KEYS.DEVICE_INFO_VARIABLE);
    }, []);

    return (
        <div className='mx-auto mb-60 flex w-408 max-w-full flex-1 flex-col items-center justify-center py-24 text-center'>
            <MoniebookLogo />

            <div className='flex w-full flex-1 flex-col justify-center px-24'>
                <img
                    className='mb-32 h-120 w-auto'
                    src='/illustrations/app-update-default.svg'
                    alt='Unsupported device'
                />

                <h2 className='mb-20 font-general-sans text-20 font-semibold text-content-heading-default'>
                    Please use a desktop or download the Moniebook app
                </h2>

                <p className='text-base font-normal text-content-subtext-default'>
                    Moniebook's Web Register isn't supported on mobile browsers.
                    To continue, please open this link on{' '}
                    <a
                        className='text-base font-normal underline'
                        target='_blank'
                        rel='noopener noreferrer'
                        href='https://www.google.com/chrome'>
                        Google Chrome for desktop
                    </a>
                    {' or '}
                    <a
                        className='text-base font-normal underline'
                        target='_blank'
                        rel='noopener noreferrer'
                        href={link}>
                        download the Moniebook app
                    </a>{' '}
                    on your device.
                </p>
            </div>
        </div>
    );
}
